import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';

export default async function getDb() {
    const firebaseConfig = {
        apiKey: "AIzaSyAXwBklAmCzL1bDutPytmwjd-P1b4lYUDs",
        authDomain: "beersport-backend.firebaseapp.com",
        projectId: "beersport-backend",
        storageBucket: "beersport-backend.appspot.com",
        messagingSenderId: "117720708853",
        appId: "1:117720708853:web:86a68ce7892da63bb6b7bc",
        measurementId: "G-98M0YER2MD"
    };

    const app = initializeApp(firebaseConfig);

    return getFirestore(app);
}
